import Popup from 'popup/Popup';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { mainSettingUpdate } from 'redux/action/mainSetting1';
import { ColumnSetPopupContainer } from './ColumnSetPopup.css';

const ColumnSetPopup = () => {
  const dispatch = useDispatch();
  const columnSetting = useSelector((state) => state.mainSetting1.board.columns);
  const userIdx = useSelector((state) => state.loginManager.status.userIdx);
  const flag_ch4_hc = useSelector((state) => state.settings.setting.flag_ch4_hc);
  const [popupOpen, setPopupOpen] = useState(false);
  const { register, handleSubmit, errors } = useForm();
  const confirmColumns = (data) => {
    dispatch({ type: 'BOARD_COLUMN_SET', data: data.column });
    dispatch(mainSettingUpdate(data.column, userIdx));
    setPopupOpen(false);
  };

  return (
    <Popup
      trigger={
        <div>
          <button className="btn btn-primary">Edit</button>
        </div>
      }
      modal
      closeOnDocumentClick
      open={popupOpen}
      onOpen={() => {
        setPopupOpen(true);
      }}
    >
      <ColumnSetPopupContainer>
        <div className="title">테이블 커스터마이징</div>
        <form onSubmit={handleSubmit(confirmColumns)}>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'logIdx'} defaultChecked={columnSetting.indexOf('logIdx') !== -1} /> No.
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'areaNo'} defaultChecked={columnSetting.indexOf('areaNo') !== -1} />{' '}
              설비번호
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'areaNm'} defaultChecked={columnSetting.indexOf('areaNm') !== -1} /> 설비명
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'modelNo'} defaultChecked={columnSetting.indexOf('modelNo') !== -1} />{' '}
              감지기No.
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'h2s'} defaultChecked={columnSetting.indexOf('h2s') !== -1} /> 
              독성가스(ppm)
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'co2'} defaultChecked={columnSetting.indexOf('co2') !== -1} /> 
              이산화탄소(ppm)
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'status'} defaultChecked={columnSetting.indexOf('status') !== -1} /> 상태
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'battery'} defaultChecked={columnSetting.indexOf('battery') !== -1} />{' '}
              배터리
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'rgstDt'} defaultChecked={columnSetting.indexOf('rgstDt') !== -1} />{' '}
              측정시간
            </label>
          </div>
          <div className="btn-box">
            <button type="submit" className="btn btn-primary">
              저장
            </button>
          </div>
        </form>
      </ColumnSetPopupContainer>
    </Popup>
  );
};

export default ColumnSetPopup;
